<div>
    <div class="pt-[30px] pb-[30px] w-full text-[20px] font-[DMSans] text-[rgba(74,74,74,1)] ">
        <div>
            Saved Auctions lets you keep track of auctions you want to follow.
        </div>
        <div>
            Add any auction to this list to easily return to it later.
        </div>
    </div>

    <div *ngIf="this.myAuctionsList()==null" class="flex justify-center items-center h-[245px]">
        <p-progress-spinner ariaLabel="loading" />
    </div>
    <div *ngIf="this.myAuctionsList()!=null && this.myAuctionsList()!.length == 0"
        class="flex justify-center items-center h-[245px]">
        <p-card class="text-center font-[DMSans] text-[16px] font-bold shadow-xl shadow-cyan-500/5">
            <p>
                You have no saved auctions.
            </p>
        </p-card>
    </div>
    <div *ngIf="this.myAuctionsList()!=null && this.myAuctionsList()!.length > 0">
        <div class="flex justify-end mb-4 lg:mb-8">
            <p-select [options]="sortFilters" placeholder="Sort by" [(ngModel)]="selectedSortSignal" class="">
                <ng-template #dropdownicon>
                    <fa-icon [icon]="faFilter" class="text-[14px] text-[rgba(74,74,74,1)]"></fa-icon>
                </ng-template>
            </p-select>
        </div>

        <p-table class="hidden lg:block" ngSkipHydration [value]="sortedItems()"
            [paginator]="this.myAuctionsList()!.length>10" [rows]="10" (onPageChange)="this.onPageChange($event)">
            <ng-template #body let-auction>
                <app-auction-item (getMyAuctionsList)="getMyAuctionsList()" [auction]="auction">
                </app-auction-item>
            </ng-template>
        </p-table>

        <div class="block lg:hidden">
            @for (auction of sortedItems(); track $index) {
            <app-auction-item (getMyAuctionsList)="getMyAuctionsList()" [auction]="auction">
            </app-auction-item>
            }
        </div>


    </div>

    <p-scrolltop class="flex lg:hidden custom-scroll-top"/>

</div>